import React from 'react';
import { MdVolumeOff, MdReplay } from 'react-icons/md';

const VoiceControls = ({ isSpeaking, stopSpeaking, replayLastMessage, lastMessageExists }) => {
  if (!lastMessageExists && !isSpeaking) return null;

  return (
    <div className="voiceControls">
      {isSpeaking ? (
        <button className="btn iconBtn dangerBtn" onClick={stopSpeaking} title="Stop Speaking">
          <MdVolumeOff size={18} />
        </button>
      ) : (
        <button className="btn iconBtn" onClick={replayLastMessage} title="Replay Last Answer">
          <MdReplay size={18} />
        </button>
      )}
    </div>
  );
};

export default VoiceControls;
